import TriggerTypes from 'eflex/constants/tasks/trigger-types';

export default function triggerTypes(type) {
  return TriggerTypes[type];
}
